













































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, PropSync, Watch} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {LadingStore} from "@/modules/ladings/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {FreightServiceType, LadingPaymentType, LadingPickupType, LadingType} from "@/enums/type";
import {
    assignValueToForm,
    getLocationFromPlaceDetail,
} from "@/shared/services/helper/utils";
import {LadingStatus} from '@/enums/status';
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {CustomerStore} from "@/modules/customers/store";
import {Customer, Lading} from "@/interfaces/entity";
import {PHONE_REGEX} from "@/shared/constant";
import LadingSelector from "@/shared/components/LadingSelector/index.vue";
import {AuthStore} from "@/modules/auth/store";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import DetailLading from "@/modules/ladings/Detail/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import CountrySelector from "@/modules/regions/CountrySelector/index.vue";
import {cloneDeep, debounce, isEqual} from "lodash"
import MapAutocomplete from "@/shared/components/MapAutocomplete/index.vue";
import {googlePlaceToLocation} from "@/modules/regions/services";
import CustomGoogleAutoComplete from "@/shared/components/CustomGoogleAutoComplete/index.vue";
import AutocompletePhoneCustomer from "@/shared/components/AutocompletePhoneCustomer/index.vue";
import FreightServiceAddSelector from "@/shared/components/FreightServiceAddSelector/index.vue";
import {CustomerType} from "@/enums/type/customertype";
import UploadMultipleImage from "@/shared/components/UploadMultipleImage/index.vue";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {saveDraft, scanLadingNeedUpdate, singleDraft} from "@/modules/ladings/services";
import LadingPrintA6 from "@/modules/ladings/Print/LabelA6/index.vue";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import {searchBillLading} from "@/modules/searchbilllading/service";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {LocationStore} from "@/modules/location/store";

const typeBoxContent = {
    DOC: "Tài liệu",
    HH: "Hàng hóa"
};

const typeNoteDelivery = {
    SHOW: "Cho xem hàng",
    HIDE: "Không xem hàng"
};

@Component({
    name: "LadingForm",
    components: {
        AInputCustom,
        LadingPrintBill,
        LadingPrintA6,
        UploadMultipleImage,
        FreightServiceAddSelector,
        AutocompletePhoneCustomer,
        CustomGoogleAutoComplete,
        MapAutocomplete,
        CountrySelector,
        DetailLadingPrint,
        PrintLading,
        DetailLading,
        UploadImage,
        LadingSelector,
        CustomerSelector,
        MillisecondDatePicker,
        FreightServiceSelector, WardSelector, DistrictSelector, ProvinceSelector, EnumSelector, InputCurrency
    },
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false})
    readonly isFormUpdate!: boolean;

    @Prop({type: Boolean, default: false})
    readonly showDetail!: boolean;

    @PropSync("id") syncId!: string;

    @Prop() draftId!: string;

    inputSize = 'small';
    showModalPrint = false;
    ladingIdPrint = "";
    labelCol = {span: 7};
    wrapperCol = {span: 17};

    LadingType = LadingType;
    LadingStatus = LadingStatus;
    FreightServiceType = FreightServiceType;
    LadingPaymentType = LadingPaymentType;
    LadingPickupType = LadingPickupType;
    CustomerType = CustomerType;

    provinceNameSender = "";
    provinceNameReceive = "";
    typeBoxContent = typeBoxContent;
    typeNoteDelivery = typeNoteDelivery;

    boxContent = this.typeBoxContent.DOC;
    noteDelivery = this.typeNoteDelivery.SHOW;
    disableLocationFrom = false;
    ladingPristine

    sender: Customer = {} as any;
    formPristine = {
        rowGuid: undefined,
        refLadingCode: undefined,
        type: LadingType.Normal,
        ladingCode: undefined,
        orderCode: undefined,
        ladingDate: (new Date()).valueOf(),
        customerRowGuid: undefined,
        receiverRowGuid: undefined,
        locationFrom: {
            phoneNumber: "",
            name: "",
            address: "",
            wardId: undefined,
            districtId: undefined,
            provinceId: undefined,
            countryId: 1
        },
        locationTo: {
            phoneNumber: "",
            name: "",
            address: "",
            wardId: undefined,
            districtId: undefined,
            provinceId: undefined,
            countryId: 1,
            latitude: undefined,
            longitude: undefined,
            province: {},
            district: {},
            ward: {}
        },
        weightTemp: 0,
        weight: undefined,
        boxContent: "",
        boxQuantity: 1,
        boxPrice: undefined,
        freightServiceRowGuid: this.freightServiceDefault,
        freightService: {},
        freightServiceAddRowGuids: [],
        pickup: LadingPickupType.Home,
        payment: LadingPaymentType.Debit,
        note: typeNoteDelivery.SHOW,
        noteOther: undefined,
        codMoney: undefined,
        fuelFee: undefined,
        regionFarFee: undefined,
        mainFee: undefined,
        vasFee: undefined,
        feeExtra: undefined,
        insuranceFee: undefined,
        totalFee: undefined,
        vat: undefined,
        internalNote: undefined,
        senderPay: undefined,
        imageUrls: "",
        images: undefined,
        receiverCollect: undefined,
        status: undefined
    };
    form = cloneDeep(this.formPristine);

    private rules = {
        rowGuid: [{required: false}],
        refLadingCode: [{required: false, message: "Chọn vận đơn liên quan", trigger: "change"}],
        type: [{required: true, message: "Chọn loại vận đơn", trigger: "change"}],
        ladingCode: [{required: false}],
        orderCode: [{required: false}],
        ladingDate: [{required: true, message: "Chọn ngày gửi", trigger: "change"}],
        customerRowGuid: [{required: true, message: "Chọn khách hàng hoặc chọn khách vãng lai", trigger: "change"}],
        locationFrom: {
            phoneNumber: [
                {pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change"}
            ],
            address: [{required: true, message: "Nhập địa chỉ", trigger: "change"}],
            wardId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
            districtId: [{required: true, message: "Chọn quận/huyện", trigger: "change"}],
            provinceId: [{required: true, message: "Chọn tỉnh/tp", trigger: "change"}],
            // countryId: [{ required: true, message: "Nhập mã dịch vụ", trigger: "change" }],
        },
        locationTo: {
            phoneNumber: [
                {required: false, message: "Nhập số điện thoại", trigger: "change"},
                {pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change"}
            ],
            name: [{required: true, message: "Nhập họ tên", trigger: "change"}],
            address: [{required: true, message: "Nhập địa chỉ", trigger: "change"}],
            districtId: [{required: true, message: "Chọn quận/huyện", trigger: "change"}],
            provinceId: [{required: true, message: "Chọn tỉnh/tp", trigger: "change"}],
            countryId: [{required: true, message: "Chọn quốc gia", trigger: "change"}],
        },
        weightTemp: [{required: false, message: "Nhập trọng lượng", trigger: "change"}],
        weight: [{required: true, message: "Nhập TL", trigger: "change"}],
        boxContent: [{required: true, message: "Nhập nội dung hàng hóa", trigger: "change"}],
        boxQuantity: [{required: true, message: "Nhập khối lượng", trigger: "change"}],
        boxPrice: [{required: false}],
        freightServiceRowGuid: [{required: true, message: "Chọn dịch vụ", trigger: "change"}],
        freightServiceAddRowGuids: [{required: false, message: "Chọn dịch vụ cộng thêm", trigger: "change"}],
        pickup: [{required: true, message: "Chọn yêu cầu lấy hàng", trigger: "change"}],
        payment: [{required: true, message: "Chọn hình thức thanh toán", trigger: "change"}],
        note: [{required: false, message: "Nhập ghi chú", trigger: "change"}],
        codMoney: [{required: false}],
        fuelFee: [{required: false}],
        regionFarFee: [{required: false}],
        mainFee: [{required: false}],
        vasFee: [{required: false}],
        totalFee: [{required: false}],
        internalNote: [{required: false}],
        senderPay: [{required: false}],
    };

    onSave($evt) {
        if ($evt.ctrlKey && ($evt.which == 83 || $evt.keyCode == 83)) {
            $evt.preventDefault();
            this.submitLading();
        }
    }

    async created() {
        if (!FreightServiceStore.ids.length) {
            await FreightServiceStore.listFreightServiceOfCustomer({});
        }
        // if (!this.formPristine.freightServiceRowGuid) this.formPristine.freightServiceRowGuid = this.freightServiceDefault;
        if (!this.syncId) {
            this.refreshForm();
        }
        if (!this.showWeight) {
            this.form.weight = 0 as any;
        }
        if (this.draftId) {
            const draft = singleDraft(this.draftId, AuthStore.user?.username);
            if (!draft) {
                this.$message.error("Vận đơn nháp không tồn tại");
                this.$router.push({ name: "ladingDraft" });
                return;
            }
            this.form = assignValueToForm(this.form, draft);
        }
        console.log('dccm', LocationStore.locationCreateLading, LocationStore.data)
        if (LocationStore.locationCreateLading) {
            this.form.locationTo.phoneNumber = LocationStore.locationCreateLading.phoneNumber
            this.form.locationTo.name = LocationStore.locationCreateLading.name
            this.form.locationTo.address = LocationStore.locationCreateLading.address
            this.form.locationTo.wardId = LocationStore.locationCreateLading.wardId as any
            this.form.locationTo.districtId = LocationStore.locationCreateLading.districtId as any
            this.form.locationTo.provinceId = LocationStore.locationCreateLading.provinceId as any
        }
        // window.addEventListener('beforeunload', function (e) {
        //     (e || window.event).preventDefault();
        //     (e || window.event).returnValue = '';
        // })
    }

    mounted() {
        window.addEventListener("keydown", this.onSave);
    }

    beforeDestroy() {
        window.removeEventListener("keydown", () => ({}));
        // window.removeEventListener("beforeunload", function (e) {
        //     (e || window.event).preventDefault();
        //     (e || window.event).returnValue = '';
        // });
        LadingStore.setPristineForm();
        LocationStore.updateLocationCreateLading({})
    }

    @Watch("form", { deep: true, immediate: false })
    onDirtyForm(val: any) {
        if (isEqual(val, this.formPristine)) return;
        LadingStore.setDirtyForm();
    }

    @Watch("form.locationTo.provinceId", {deep: true})
    async onReceiverLocationProvinceId() {
        this.calculateMoney();
    }

    @Watch("form.locationTo.districtId", {deep: true})
    async onReceiverLocationDistrictId() {
        this.calculateMoney();
    }

    @Watch("form.locationFrom.provinceId", {deep: true})
    async onSenderLocationProvinceId() {
        this.calculateMoney();
    }

    @Watch("form.locationFrom.districtId", {deep: true})
    async onSenderLocationDistrictId() {
        this.calculateMoney();
    }

    @Watch("form.freightServiceRowGuid", {deep: true})
    async onFreightServiceRowGuid() {
        this.calculateMoney();
    }

    @Watch("form.freightServiceAddRowGuids", {deep: true})
    async onFreightServiceAddRowGuids() {
        this.calculateMoney();
    }

    @Watch("form.weightTemp", {deep: true})
    onWeightTemp() {
        this.handleWeightTempChange(this);
    }

    @Watch("form.boxPrice", {deep: true})
    onBoxPriceChange() {
        this.handleBoxPriceChange(this)
    }

    handleBoxPriceChange = debounce((vm) => {
        vm.calculateMoney();
    }, 500)

    handleWeightTempChange = debounce((vm) => {
        if (vm.form.weight) return;
        vm.calculateMoney();
    }, 500);

    @Watch("form.weight", {deep: true})
    onWeight() {
        this.handleWeightChange(this);
    }

    handleWeightChange = debounce((vm) => {
        vm.calculateMoney();
    }, 500);

    @Watch("form.codMoney", {deep: true})
    onCodMoney() {
        this.calculateMoney();
    }

    @Watch("form.payment", {deep: true})
    onPayment() {
        this.calculateMoney();
    }

    @Watch("form.feeExtra", {deep: true})
    onFeeExtra() {
        this.handleFeeExtraChange(this);
    }

    handleFeeExtraChange = debounce((vm) => {
        vm.calculateMoney();
    }, 500);

    @Watch("form.type", {deep: true})
    onType(val: number) {
        if (val === LadingType.Retransport || val === LadingType.Forward) {
            this.rules["refLadingCode"] = [{required: true, message: "Chọn vận đơn liên quan", trigger: "change"}];
        }
    }

    @Watch("form.refLadingCode", {deep: true})
    onRefLadingCode(val: string, oldVal: string) {
        if (val === oldVal || !val) return;
        this.handleRefLadingCode(val, this);
    }

    handleRefLadingCode = debounce(async (val, vm) => {
        try {
            const {data} = await searchBillLading(val);
            const billLading: Lading = data.data;
            if (!billLading) return;
            CustomerStore.addCustomer(billLading.customer);
            if (billLading.customer.postOfficeRowGuid !== AuthStore.user?.employee?.postOfficeRowGuid) {
                this.disableLocationFrom = true;
            }
            switch (vm.form.type) {
                case LadingType.Forward:
                    vm.handleForwardBill(billLading, vm);
                    break;
                case LadingType.Retransport:
                    vm.handleReTransportBill(billLading, vm);
                    break;
                default:
                    break;
            }
        } catch (e) {
        }
    }, 500)

    handleReTransportBill(billLading: Lading, vm) {
        vm.form = {
            ...assignValueToForm(this.form, billLading),
            type: LadingType.Retransport,
            refLadingCode: vm.form.refLadingCode,
            ladingCode: undefined,
            orderCode: undefined,
            ladingDate: (new Date()).valueOf()
        };
        vm.form.locationTo = {...vm.form.locationFrom};
        vm.form.locationFrom = {
            ...vm.form.locationFrom,
            address: AuthStore.user.employee?.postOffice?.address as any,
            provinceId: AuthStore.user.employee?.postOffice?.provinceId as any,
            districtId: AuthStore.user.employee?.postOffice?.districtId as any,
            wardId: AuthStore.user.employee?.postOffice?.wardId as any
        } as any;
    }

    handleForwardBill(billLading: Lading, vm) {
        vm.form = {
            ...assignValueToForm(this.form, billLading),
            type: LadingType.Forward,
            refLadingCode: vm.form.refLadingCode,
            ladingCode: undefined,
            orderCode: undefined,
            ladingDate: (new Date()).valueOf(),
            fuelFee: undefined,
            regionFarFee: undefined,
            mainFee: undefined,
            vasFee: undefined,
            feeExtra: undefined,
            totalFee: undefined,
            vat: undefined,
            senderPay: undefined,
            receiverCollect: undefined
        };
        vm.form.locationFrom = {
            ...vm.form.locationTo
        } as any;
        vm.form.locationTo = {...this.formPristine.locationTo};
    }

    async calculateMoney() {
        if (
            this.form.customerRowGuid
            && this.form.locationTo.countryId
            && this.form.locationTo.provinceId
            && this.form.locationTo.districtId
            && this.form.freightServiceRowGuid
            && this.form.freightServiceAddRowGuids
            && (this.form.weightTemp || this.form.weight || this.form.weight === 0)
            && this.form.payment
        ) {
            try {
                const results = await LadingStore.calculateMoney({
                    ...{},
                    customerRowGuid: this.form.customerRowGuid,
                    receiverCountryId: this.form.locationTo.countryId,
                    receiverProvinceId: this.form.locationTo.provinceId,
                    receiverDistrictId: this.form.locationTo.districtId,
                    receiverWardId: this.form.locationTo.wardId,
                    weight: this.form.weight || this.form.weightTemp,
                    freightServiceRowGuid: this.form.freightServiceRowGuid,
                    freightServiceAddRowGuids: this.form.freightServiceAddRowGuids.join(","),
                    payment: this.form.payment,
                    codMoney: this.form.codMoney || 0,
                    feeExtra: this.form.feeExtra || 0,
                    boxPrice: this.form.boxPrice || 0
                });
                results.forEach((result: any) => {
                    switch (result.serviceCode) {
                        case "ALL":
                            this.form.totalFee = result.price;
                            break;
                        case "ALL_VAS":
                            this.form.vasFee = result.price;
                            break;
                        case "MAIN":
                            this.form.mainFee = result.price;
                            break;
                        case "PXD":
                            this.form.fuelFee = result.price;
                            break;
                        case "PVX":
                            this.form.regionFarFee = result.price;
                            break;
                        case "VAT":
                            this.form.vat = result.price;
                            break;
                        case "SENDER_PAY":
                            this.form.senderPay = result.price;
                            break;
                        case "RECEIVER_COLLECT":
                            this.form.receiverCollect = result.price;
                            break;
                        case "INSURANCE":
                            this.form.insuranceFee = result.price
                            break;
                        default:
                            break;
                    }
                });
            } catch (e) {
                this.$message.error({content: e?.response?.data?.message || "Tính phí thất bại"});
            }
        }
    }

    async onPlaceChangeSender(placeDetail) {
        const {data} = await googlePlaceToLocation(getLocationFromPlaceDetail(placeDetail));
        this.form.locationFrom = {
            ...this.form.locationFrom,
            provinceId: data?.data?.province?.id,
            districtId: data?.data?.district?.id,
            wardId: data?.data?.ward?.id
        };
        this.validateLocationFrom();
    }

    async onPlaceChangeReceive(placeDetail) {
        const {data} = await googlePlaceToLocation(getLocationFromPlaceDetail(placeDetail));
        this.form.locationTo = {
            ...this.form.locationTo,
            provinceId: data?.data?.province?.id,
            districtId: data?.data?.district?.id,
            wardId: data?.data?.ward?.id,
            latitude: placeDetail?.geometry?.location?.lat(),
            longitude: placeDetail?.geometry?.location?.lng()
        };
        this.validateLocationTo();
    }

    onSenderChange() {
        if (!this.form.customerRowGuid) return;
        this.sender = CustomerStore.data[this.form.customerRowGuid as any];
        if (!this.sender) return;
        if (this.sender.type === CustomerType.Customer) {
            this.form.locationFrom = {
                ...this.form.locationFrom,
                phoneNumber: "",
                name: "",
                address: this.sender.address,
                provinceId: this.sender.provinceId as any,
                wardId: this.sender.wardId as any,
                districtId: this.sender.districtId as any
            };
            this.validateLocationFrom();
        } else {
            this.form.locationFrom = {...this.formPristine.locationFrom};
            this.$nextTick(() => this.clearValidateLocationFrom());
        }
    }

    onReceiverChange(val: any) {
        console.log(val);
        if (!val) return;
        this.form.locationTo = {
            ...this.form.locationTo,
            name: val?.name,
            address: val?.address,
            wardId: val?.wardId,
            districtId: val?.districtId,
            provinceId: val?.provinceId,
            countryId: val?.countryId || 1,
            latitude: val?.latitude,
            longitude: val?.longitude,
            province: val?.province,
            district: val?.district,
            ward: val?.ward
        }
        this.validateLocationTo();
        (this.$refs.boxContentLading as any).$el.focus();
    }

    private submitLading(choose = 'no-print') {
        (this.$refs.formLading as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                let lading: Lading = undefined as any;
                this.syncId
                    ? lading = await LadingStore.updateLading({
                        ...this.form,
                        images: this.form.images ? [this.form.images] : undefined
                    })
                    : lading = await LadingStore.createLading({
                        ...this.form,
                        images: this.form.images ? [this.form.images] : undefined
                    });

                if (lading && choose === 'printBill') {
                    this.ladingIdPrint = lading?.rowGuid as any;
                    (this.$refs.showChoosePrintLading as any).showChoosePrintLading();
                }
                this.$message.success({
                    content: `${this.syncId ? 'Sửa' : 'Tạo'} đơn thành công`
                });
                if (!this.syncId) {
                    this.refreshForm();
                } else {
                    this.$router.push({ name: "listLading" });
                    // this.form = {
                    //     ...cloneDeep(this.formPristine),
                    //     freightServiceRowGuid: FreightServiceStore.freightServiceDefault?.rowGuid as any
                    // };
                    // LadingStore.clearDataCached();
                    // LadingStore.addDataCached(lading);
                    // LadingStore.removeLading(lading);
                    // (this.$refs.ladingCode as any).$el.focus();
                    // this.$nextTick(() => {
                    //     this.clearValidateLocationTo();
                    //     this.clearValidateLocationFrom();
                    // })

                    // const nextLading: Lading|undefined = LadingStore.ids[0] ? LadingStore.data[LadingStore.ids[0]] : undefined;
                    // if (nextLading) {
                    //     setTimeout(() => {
                    //         this.form.ladingCode = nextLading.ladingCode as any;
                    //         this.handleChangeLadingCode(this.form.ladingCode, this);
                    //     }, 500)
                    // }
                }
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || `${this.syncId ? 'Sửa' : 'Tạo'} vận đơn thất bại`}`
                })
            }
        })
    }

    @Watch("syncId")
    async onChangeId() {
        if (this.syncId) {
            try {
                const data = await LadingStore.singleLading(this.syncId);
                this.form = {
                    ...assignValueToForm(this.form, data),
                    locationFrom: data.locationFrom || {
                        ...this.formPristine.locationFrom
                    },
                    locationTo: data.locationTo || {
                        ...this.formPristine.locationTo
                    },
                    weightTemp: data.weightTemp || 0,
                    weight: data.weight || 0,
                    boxQuantity: data.boxQuantity || this.formPristine.boxQuantity,
                    boxContent: data.boxContent || this.formPristine.boxContent,
                    freightServiceRowGuid: data.freightServiceRowGuid || this.freightServiceDefault,
                    note: data.note || this.formPristine.note,
                    images: this.getProp(data, 'images[0]', undefined),
                    imageUrls: this.getProp(data, 'imageUrls[0]', ""),
                    payment: data.payment || LadingPaymentType.Debit
                };
                CustomerStore.addCustomer(data.customer);
                this.sender = CustomerStore.data[this.form.customerRowGuid as any];
                // (this.$refs.orderCode as any).$el.focus();
            } catch (e) {
                console.log(e);
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra s"}`
                })
            }
        }
    }

    onChangeLadingCode(evt: any) {
        const val = evt?.target?.value;
        if (!val || !this.isFormUpdate || this.showDetail) return;
        this.handleChangeLadingCode(val, this);
    }

    handleChangeLadingCode = debounce(async (val: any, vm: any) => {
        try {
            const {data} = await scanLadingNeedUpdate(val);
            const billLading = data.data;
            vm.syncId = billLading?.rowGuid;
        } catch (e) {
            vm.$message.error({
                content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
            })
        }
    }, 800)

    logChange(val) {
        console.log(val);
    }

    changeBoxContent($evt: any) {
        this.form.boxContent = $evt.target.value;
    }

    printLading() {
        this.ladingIdPrint = this.syncId;
        this.showModalPrint = true;
    }

    refreshForm() {
        (this.$refs.formLading as FormModel)?.resetFields();
        this.form.customerRowGuid = AuthStore.user?.customer?.rowGuid as any;
        this.form.locationFrom = {
            ...this.form.locationFrom,
            phoneNumber: AuthStore.user?.customer?.senderPhone as any,
            name: AuthStore.user?.customer?.sender as any,
            address: AuthStore.user?.customer?.address as any,
            provinceId: AuthStore.user?.customer?.provinceId as any,
            wardId: AuthStore.user?.customer?.wardId as any,
            districtId: AuthStore.user?.customer?.districtId as any
        };
        this.form.weight = this.showWeight ? undefined : 0 as any;
        this.form.freightServiceRowGuid = this.freightServiceDefault;
        this.syncId = '';
        this.$nextTick(() => {
            this.clearValidateLocationTo();
            this.clearValidateLocationFrom();
        });
        LadingStore.setPristineForm();
    }

    validateLocationFrom() {
        (this.$refs.formLading as any).validateField(["locationFrom.countryId", "locationFrom.provinceId", "locationFrom.districtId", "locationFrom.wardId"], () => ({}));
    }

    validateLocationTo() {
        (this.$refs.formLading as any).validateField(["locationTo.countryId", "locationTo.provinceId", "locationTo.districtId", "locationTo.wardId"], () => ({}));
    }

    clearValidateLocationTo() {
        (this.$refs.formLading as any).clearValidate(["locationTo.countryId", "locationTo.provinceId", "locationTo.districtId", "locationTo.wardId"]);
    }

    clearValidateLocationFrom() {
        (this.$refs.formLading as any).clearValidate(["locationFrom.countryId", "locationFrom.provinceId", "locationFrom.districtId", "locationFrom.wardId"]);
    }

    saveDraft() {
        (this.$refs.formLading as FormModel).validate( valid => {
            if (!valid) return;
            saveDraft(this.form as any, AuthStore.user?.username);
            this.refreshForm();
        })
    }
}
